<template>
  <SkeletonRoot
    v-for="(_, index) in size"
    :delay="Math.floor(index / (deviceType === 'MOBILE' ? 2 : 6))"
  >
    <Skeleton
      aspect-ratio="1"
    />
    <div :style="{ marginTop: '8px', paddingLeft: '4px' }">
      <Skeleton width="80px" />
      <Skeleton height="16px" />
      <Skeleton width="80px" />
      <Skeleton
        :style="{ marginTop: '12px' }"
        height="16px"
      />
      <Skeleton width="80px" />
    </div>
  </SkeletonRoot>
</template>

<script setup>
import { SkeletonRoot, Skeleton } from '@/components/Skeleton'
import { useDevice } from '@/hooks/useDevice'

const props = defineProps({
  length: {
    type: Number,
    default: 0
  }
})
const { deviceType } = useDevice()

const size = computed(() => {
  if (props.length === 0) return 60
  return props.length & 6 === 0 ? 6 : (6 - (props.length % 6)) + 6
})
</script>

<style lang="less">
</style>
